/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import {userService} from "../views/service/user.service";
import Vue from "vue";
import _ from "lodash";

const state = {
    users: [],
    currentTab: 1,
    affected: false
};
const getters = {
    getUsers: state => state.users,
    getCurrentTab(state){
        return state.currentTab;
    },
    getAffected: state => state.affected
};
const actions = {
    lookupUsersAction({commit}, {pagedFilter, showLoader}) {

        userService.lookup(pagedFilter, showLoader)
            .then(res => {
                commit('usersMutation', res);
            })
    },
    lookupUsersAgenceAction({commit}, {pagedFilter, idAgence, showLoader}) {
        userService.agenceUsers(pagedFilter, idAgence, showLoader)
            .then(res => {
                commit('usersMutation', res);
            })
    },
    changeActivation({commit, dispatch}, {id, isEnabled, assignedUser, pagedFilter, isAgenceTeam, idAgence}) {
        userService.changeActivation({id, isEnabled, assignedUser})
            .then(res => {
                if(isAgenceTeam) dispatch('lookupUsersAgenceAction', {pagedFilter, idAgence,showLoader: false})
                else dispatch('lookupUsersAction', {pagedFilter, showLoader: false})
            })
            .catch(error => {
                Vue.$log.error(error);
            })
    }
};
const mutations = {
    usersMutation: (state, users) => {
        state.users = users;
        state.users.content = _.map(users.content, function(element) {
            return _.extend({}, element, {shouldLoading: false});
        });
    } ,

    setShouldLoading(state, val) {
        state.users.content.forEach(user => {
            if (user.id === val){
                user.shouldLoading = true;
            }
        })
    },
    setShouldNotLoading(state, val) {
        state.users.content.forEach(user => {
            if (user.id === val){
                user.shouldLoading = false;
            }
        })
    },
    goNext(state, tab){
        state.currentTab = tab;
    },
    setAffected(state, val){
        state.affected = val;
    }
};

export const user = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};


